module.exports = "/shifts/components/dynamicLaborSummaryItemComponent-7062b9.html";